module.exports = __webpack_public_path__ + "img/category-casino.49f13540.png";